module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Fortune")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "9781460303092.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("4")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("M")])])])]), _vm._v("arvel’s Carnival was a seedy, tired affair, one of the last of its kind, a dying breed. Forty years prior, before the proliferation of high-tech, big-bucks amusement worlds like Six Flags, Marvel’s had been in its heyday. Part amusement park, part circus, the carnival and its troupe traveled from town to town during the summer months, staying a few days or a week, then moving on.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("These days, a carnival like Marvel’s was in less demand than during that glorious heyday. Now the troupe only traveled to small rural areas. Places with little access to big, fancy theme parks, places where the kids—young and old—were hungry for something to do, some way to fill the long summer nights.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Marvel’s gave them plenty to do, plenty to gawk at. The fire-eaters and snake charmers were a big favorite with the preadolescent crowd, the teenagers gravitated toward the rides and games of chance, the adults to the food, acrobats and contortionists. Everybody loved the fortune-teller, especially this summer, as the show’s owner had managed to snare a really good one.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Claire Dearborn—known as Madame Claire on the circuit—was the real thing, the genuine article, not a scam artist or slick fraud like most of the other sideshow acts. If Abner Marvel had had any doubts about that when he’d hired her, those doubts had quickly disappeared as word spread and the towners began lining up to have their fortunes told.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Abner Marvel, one of the last of the born-and-bred showmen, had quickly given the woman and her daughter their own trailer and raised the cost of a five-minute reading from two dollars to five. Additional time could be purchased, of course. At a premium.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In twelve-year-old Skye Dearborn’s opinion, her mother could make a lot more money with her ability than she did working for this third-rate, traveling fleabag, but the one time Skye had suggested it her mother had said she liked traveling with Marvel’s and that money didn’t buy happiness.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye supposed she liked the traveling, too, but she didn’t follow the bit about money and happiness. From what she had seen of life, rich folks seemed a whole lot happier than poor ones.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye ducked out of her and her mother’s trailer and headed toward the midway. Living accommodations for the entire troupe, the trailers were positioned on the northern-most edge of the lot, as far as possible from the activity of the show. Even so, she could hear the carousel’s calliope and the screams of delighted terror coming from the Screamin’ Demon, the show’s rather modest roller coaster.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She and her mother were traveling with Marvel’s for the summer; come fall they would settle somewhere, some little town where her mom would get a job at the local diner or drugstore and where she would go to school. Skye made a face. School sucked. She hated everything about it except art class, and some of the schools she had gone to had been so small and backward they didn’t even have art. Then it totally sucked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In truth, whether the school had art or not never really mattered, ’cause she and her mom never stayed in any one place too long. Just about the time she had gotten her reputation as a smart-mouthed troublemaker good and fixed, they would move on. Skye could count more than a dozen schools she’d attended in the last couple of years.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She and her mom had been traveling this way for as long as she could remember. Her mom said they were nomadic adventurers; Skye kind of thought they might be criminals or something. All the moving around, to her mind, just didn’t add up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye frowned and kicked at a discarded Coke can. Still half-full, the beverage spewed out, splattering her shorts and T-shirt. Making a sound of annoyance, she swiped at the drops of cola. If only her mom would tell her the truth. The few times Skye had confronted her, her mother had denied keeping anything from her; she had denied having any secrets.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was lying; Skye was certain of it. She had the feeling that her mother was running, that she was constantly looking over her shoulder. That she was always afraid.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And that made Skye afraid, too. Her mother was all she had.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She climbed over the rope barricade that circled the perimeter of the show and separated what was called the front yard from the back yard, the towners from the troupers. Up ahead lay the midway, with its bright lights and raucous laughter, its frenetic mix of music, games and tasty treats. The rides flanked either side of the midway; the sideshow tents—including her mother’s—were located at its far end.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye didn’t have a set job with the troupe, but helped out as she was needed, filling in for troupers who were ill, helping set up and tear down, but mostly, she worked as a sort of shill on the midway, drumming up business for the various games of chance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A “sort of” shill because Marvel’s was a one-hundred-percent Sunday-school show—no overcharging or shortchanging customers, no rigged games. Skye had played each game about a million times; she knew the trick to winning at each, so she made it look easy. So easy, in fact, that as she walked away, arms full of prizes, folks lined up, eager to win one of the big stuffed toys.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As Skye stepped onto the midway, the scent of popcorn hit her in a mouthwatering wave. Nearly 8:00 p.m., the carnival was in full swing, the midway packed, even for a Saturday night. Skye moved her gaze up, then down, the aisle of game booths, noting that most were busy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("All except the quarter toss.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She ambled over, stopped at the booth as if sizing it up, then dug in her pocket for a quarter. “What do I do?” she asked Danny, an obnoxious zit-face of a boy who seemed to have made tormenting her his life’s work. But still, this was business. She had to get along with him for the good of the troupe.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He sidled over. “See those platforms there?” He pointed at the three levels of platforms topped with round pieces of thick, slick glass. She nodded. “Just toss your quarter. If it lands and sticks to the low platform, you win a small prize, the middle platform a medium prize, and the high platform a grand prize.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s all?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s it.” He grinned slyly. “Easy as pie.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye tried, deliberately missing twice for the sake of realism. The third time, she expertly flipped the coin so it would land flat on one of the glass tops.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It did, and she clapped her hands together. “I won!” she squealed. She swung, as with excited, disbelieving delight, toward the people in the aisle behind her. “I won! I can’t believe it!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Here you go, little lady,” Danny said, and handed her a stuffed parrot. “You wouldn’t like to give it another try, would you? And go for one of the grand prizes. You seem awful good at this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sure.” Skye grinned. “I’ll try again.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A handful of quarters later, she walked away from the now-crowded booth, her arms loaded with stuffed toys. She went to the supply wagon to dump them—she never kept what she won, that wouldn’t be right—then skipped back to the midway for some more fun.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A commotion at the concession stand caught her attention. A teenager stood at the front of the line, clutching his stomach and holding out a half-eaten hot dog.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“This made me sick,” the boy said loudly. “I think it’s bad or something.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye inched closer to get a better look. She saw Marta, a big woman with steel gray hair and a personality to match, eye the boy suspiciously. “What do you mean, it made you sick?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sick. You know.” He groaned and clutched his stomach, then doubled over as with cramps. The people behind him in line stirred and moved backward. He raised his voice a bit more. “Isn’t it against the law to serve rotten meat?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We don’t serve rotten meat,” Marta said, her voice shrill. “We’re very careful.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Smell it.” He held it out. “It smells rotten.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Marta leaned away, her face twisting with distaste. “I don’t want to smell it. If it’s a problem, I’ll give you back your money. Or another hot dog.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Another hot—” He moaned. “I want to talk to the owner or manager or something. This isn’t right.” He doubled over, groaning. “If I die, it’s going to be your fault.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The line stirred again; several people turned and walked away. Someone said something nasty about carnivals. Skye frowned, studying the boy. He looked kind of weird. His jeans were strictly high-water, his hair cropped unevenly, as if done by hand with a pair of kitchen shears. The front of his T-shirt was emblazoned with the name of a rock group that hadn’t been popular in a year, and instead of tennis shoes, he wore some kind of funky work boots.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Weird, she thought again. This kid wasn’t for real. He was trying to scam Marta, no doubt about it. She had seen a hint of a smile tug at his mouth as he bent over the last time. Skye cocked her head, indignant. But why? What did he hope to gain?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Money, no doubt. She folded her arms across her chest, disgusted. The lengths some people would go to for money.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Abner Marvel’s the owner,” Marta was saying, obviously anxious to get rid of him before he tossed his cookies. “You can probably find him at the little top. That’s the sideshow tent.” The woman pointed. “At the end of the midway. If he’s not there, try the main ticket booth.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Still clutching both his stomach and the hot dog, the kid turned and hobbled in the direction she’d indicated.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye narrowed her eyes. She made it her business to know everything that went on at Marvel’s. She knew what all the members of the troupe were up to, including who was doing what and with whom. A person couldn’t burp on the lot without her finding out about it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She meant to get to the bottom of this, too. Nobody was going to pull a fast one on Marvel’s, not if she had anything to say about it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She started after him, keeping him in sight but keeping her distance, too. After he had gone some distance, he straightened, glanced back at Marta and the concession stand, then smiled. A moment later, he tossed the hot dog into the trash can and started walking again—this time both upright and quickly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye made a sound of triumph. She knew it, the creep was up to something.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey! Brat-face!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye stopped and glared over her shoulder at Rick, the kid who ran the shooting gallery, a particularly odious creature. When she and her mother had first joined Marvel’s, he and a couple of his equally gross friends had tried to scare her by locking her in the fun house after closing. Instead of scaring her, he’d made her mad. When one of the roustabouts discovered her and let her out, she’d found Rick and popped him square in the nose, bloodying it. He had never forgiven her for that. But he’d never tried to scare her again, either.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She propped her fists on her hips. “What do "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("you")])]), _vm._v(" want?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I gotta take a break.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So take it. I’m busy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Marvel sent Benny to cover the coaster for a while. If I don’t get to the john, I’m going to piss on one of the customers. Get over here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye looked at the mystery kid’s retreating back, then at Rick. She sniffed. “Do you always have to be so gross? You’re disgusting. Find somebody else.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“If you don’t get your ass over here, I’m gonna beat the shit out of you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yeah, right. I’m so scared.” She cocked her chin up. “Pretty clever, the way you sneaked off the lot last night to meet that girl. Hardly anybody saw you. Except me. What do you think Marvel would say about that?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His face turned beet red. He glanced at her, and shoved his hands in the back pockets of his blue jeans. “You’re such a little twit. I wish you’d fall off the face of the planet.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And you’re a brainless butthead.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re just jealous ’cause no boy’s ever going to want to sneak out to meet you. You’re probably a queer, you act more like a boy than a girl.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For a moment, Skye couldn’t find her breath. Her eyes burned and her chest ached. Horrified, she struggled for a comeback, struggled to keep Rick from seeing how much his comment hurt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She tipped her chin up again, as much for show as to keep it from wobbling. Why should she care if Rick thought she was ugly and unlovable? So what if he thought she was a…queer. He was gross and stupid, and she hated him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You better watch it,” she said, “or I’ll get my mom to put a curse on you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Rick snorted with amusement, but only after a moment’s telling hesitation. Showmen were notoriously superstitious. They believed in bad luck and gris-gris and witches. And the truth was, her mother’s ability scared them silly. They thought that, somehow, if Madame Claire could see their future—which she could—she could also change it. For the worse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Because of that, they kept as far away from Madame Claire as possible.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye grinned. Silly, superstitious delinquents. It didn’t work that way, of course. But if they wanted to believe it did, that suited Skye just fine. Her mother wasn’t interested in being one of them, and Skye liked being able to yank their chains every once in a while. Sometimes a girl needed a little threat to hang over a bully’s head; it was a way to even the odds a bit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye knew using the other trouper’s fear of her mother’s ability that way didn’t make her too popular, but that was tough nuts. She was used to not being liked, to not having friends. Besides, when she and her mom left, she wouldn’t be leaving anyone behind. Goodbyes were a real bummer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But detest Rick or not, she was part of the troupe. And he needed her help.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Skye took one last look at the direction the mystery kid had disappeared, sighed and turned back to Rick. “Go already. But hurry back. I’ve got things to do.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f354620","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781460303092_ch04.vue
// module id = 90
// module chunks = 0